import { render } from "./ScanQR.vue?vue&type=template&id=60461406"
import script from "./ScanQR.vue?vue&type=script&lang=js"
export * from "./ScanQR.vue?vue&type=script&lang=js"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__